module.exports = __webpack_public_path__ + "static/media/windChimes21.23968c2c.mp3";